<template>
  <el-form :model="followModel" :rules="followRule" ref="followForm" class="mb20">
    <div class="add-style">
      <img class="add-style-icon" :src="require('@/assets/images/de-edit.png')" />
      <span class="add-style-label">写跟进</span>
      <div class="flexAll">
        <el-select class="add-style-text" v-model="followModel.way" placeholder="请选择跟进类型" @change="handleChangeWay">
          <el-option v-for="(value, key) in opts.follow_up_custom_ways" :key="key" :value="key" :label="value"></el-option>
        </el-select>
        <el-select class="add-style-text" v-model="followModel.sub_way" placeholder="请选择通话状态" v-if="followModel.way == 2">
          <el-option v-for="(value, key) in opts.follow_up_custom_ways_tel" :key="key" :value="key" :label="value"></el-option>
        </el-select>
        <el-select class="add-style-text" v-model="followModel.level" placeholder="请选择客户等级">
          <el-option v-for="(value, key) in opts.customer_levels_for_create" :key="key" :value="key" :label="value">
          </el-option>
        </el-select>
      </div>
    </div>
    <el-form-item prop="content" class="mt15">
      <follow-content v-bind:model_content.sync="followModel.content" ref="followContentRef" @handleChangeType="handleChangeType" @handleMutipleSet="handleMutipleSet" @handleSingleSet="handleSingleSet"/>
    </el-form-item>
    <div class="custome-add-follw-extract">
      <div>
        <span class="extra-label">下次跟进时间</span>
        <el-date-picker class="add-follow-style" type="datetime" v-model="followModel.next_follow_up_time" placeholder="请选择下次跟进时间" format="yyyy-MM-dd HH:mm" value-format="timestamp" :picker-options="followNextOpt" @change="handleChangeNextTime"></el-date-picker>
      </div>
      <div  v-if="!followModel.disable_time_type && followModel.next_follow_up_time">
        <span class="extra-label">下次跟进提醒时间</span>
        <el-select class="add-style-text"  v-model="followModel.next_follow_up_time_type" placeholder="请选择截止时间" :disabled="followModel.disabled == 2" clearable>
          <el-option v-for="status in finishList" :key="status.id" :value="status.id" :label="status.name" :disabled="status.id >= diffType"></el-option>
        </el-select>
      </div>
    </div>
    <p class="next-follow-times" v-if="followModel.next_follow_up_time_type">小云将在「{{nextFollowTime}}」提醒您再次跟进客户</p>
    <el-button size="mini" class="btn-follow mt15" @click="save">保存</el-button>
  </el-form>
</template>
<script>
import {validatRemark} from '@/utils/validate';
import {customeFollowAdd} from '@/api/custome';
import { configKeys } from '@/setting/index';
import { mapState } from 'vuex';
import FollowContent from '@/components/followContent';
import {getUnFinishTask} from '@/api/task';
import {parseTime} from '@/utils/index';
export default{
  name: 'JourneyAddFollow',
  components: {FollowContent},
  props: {
    customeId: [Number, String],
    baseInfo: Object
  },
  data () {
    return {
      followModel: {
        way: '2',
        sub_way: '1',
        content: '',
        level: '',
        next_follow_up_time: '',
        next_follow_up_time_type: '',
        complete_task_id:''
      },
      followRule: {
        content: [
          {validator: validatRemark, name: '跟进内容',isEmpty: false, trigger: 'blur'}
        ]
      },
      opts: {},
      followNextOpt: {
        disabledDate: time => {
          const timeAfter = time.getTime() < Date.now() - 8.64e7;
          let currentTime = new Date();
          currentTime = currentTime.setMonth(currentTime.getMonth() + 3)
          return timeAfter || time.getTime() > currentTime;
        }
      },
      finishList: [
        {id: 1, name: '截止前15分钟'},
        {id: 2, name: '截止前1小时'},
        {id: 3, name: '截止前3小时'},
        {id: 4, name: '截止前1天'},
      ],
      areaList: [
        {id: 1, name: '50㎡以下', min: '', max: 50},
        {id: 2, name: '50-70㎡', min: 50, max: 70},
        {id: 3, name: '70-90㎡', min: 70, max: 90},
        {id: 4, name: '90-110㎡', min: 90, max: 110},
        {id: 5, name: '110-130㎡', min: 110, max: 130},
        {id: 6, name: '130-150㎡', min: 130, max: 150},
        {id: 7, name: '150㎡以上', min: 150, max: ''}
      ],
      priceList: [
        {id: 1, name: '40万以下', min: '', max: 40},
        {id: 2, name: '40-60万', min: 40, max: 60},
        {id: 3, name: '60-80万', min: 60, max: 80},
        {id: 4, name: '80-100万', min: 80, max: 100},
        {id: 5, name: '100-150万', min: 100, max: 150},
        {id: 6, name: '150-200万', min: 150, max: 200},
        {id: 7, name: '200万以上', min: 200, max: ''}
      ],
      diffType: 100
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    // 计算下次跟进的提醒时间
    nextFollowTime () {
      if (!this.followModel.next_follow_up_time_type || !this.followModel.next_follow_up_time) return '';
      const date = new Date(this.followModel.next_follow_up_time);
      const type = this.followModel.next_follow_up_time_type;
      if (type == 1) {
        date.setMinutes(date.getMinutes() - 15);
      } else if (type == 2) {
        date.setHours(date.getHours() - 1);
      } else if (type == 3) {
        date.setHours(date.getHours() - 3);
      } else if (type == 4) {
        date.setDate(date.getDate() - 1);
      }
      return parseTime(date, '{y}年{m}月{d}日 {h}:{i}:{s}');
    }
  },
  async created() {
    if (this.baseInfo.level != 99) {
      this.$set(this.followModel, 'level', this.baseInfo.level);
    }
    this.opts = await this.$store.dispatch('initConfig', [configKeys.follow_up_custom_ways, 'follow_up_custom_ways_tel', 'customer_levels_for_create']);
    this.initUndealTask()
  },
  methods: {
    async initUndealTask () {
      try {
          const res = await getUnFinishTask(this.customeId);
          const taskId = res.id ? res.id : null;
          if (taskId) {
            this.$set(this.followModel, 'complete_task_id', taskId);
          }
        } catch (error) {
          this.$message.error(error.msg || '查询联系人列表出现错误');
        }
    },
    // 切换跟进方式
    handleChangeWay () {
      this.$set(this.followModel, 'sub_way', this.followModel.way == 2 ? '1' : '');
    },
    handleSingleSet (name, value, status) {
      this.$set(this.followModel, name, value);
    },
    handleMutipleSet (name, value,status) {
      let list = this.followModel[name] || [];
      list.push(value);
      this.$set(this.followModel, name, list);
    },
      // 切换价格/面积
    handleChangeType (data, type,status) {
      this.$set(this.followModel, type + '_id',data.id);
    },
    save () {
      this.$refs?.followForm?.validate(async valid => {
        if (!valid) return null;
        try {
          const params = {
            customer_id: this.customeId,
            way: this.followModel.way,
            content: this.followModel.content,
          }
          if (this.followModel.way == 2) params.sub_way = this.followModel.sub_way;
          if (this.followModel.level) params.level = this.followModel.level;
          if (this.followModel.next_follow_up_time) {
            params.next_follow_up_time = parseInt(this.followModel.next_follow_up_time / 1000);
            params.next_follow_up_time_type = this.followModel.next_follow_up_time_type;
          }
          ['level', 'qualifications', 'location', 'area_min', 'area_max', 'price_min', 'price_max', 'next_follow_up_time_type', 'complete_task_id'].map(v => {
            if (this.followModel[v]) {
              params[v] = Number(this.followModel[v]);
            }
          });
          ['label', 'house_type', 'room_id', 'city_area_id'].map(v => {
            if (this.followModel[v] && this.followModel[v].length > 0) {
              params[v] = this.followModel[v].filter(a => {
                return a != '';
              }).join(',');
            }
          });
           // 拼接可选意向面积
           if (this.followModel.area_id) {
            const area = this.areaList.find(v => v.id == this.followModel.area_id);
            params.area_min = area.min;
            params.area_max = area.max;
          }
          // 拼接可选意向价格
          if (this.followModel.price_id) {
            const price = this.priceList.find(v => v.id == this.followModel.price_id);
            params.price_min = price.min;
            params.price_max = price.max;
          }
          await customeFollowAdd(params);
          this.$message.success('跟进提交成功');
          this.$parent.reload();
          this.followModel = {
            way: '2',
            sub_way: '1',
            content: '',
            level: this.baseInfo.level == '99' ? '' : this.baseInfo.level,
            next_follow_up_time: '',
            next_follow_up_time_type: ''
          }
          this.$refs.followContentRef.clear();
          this.$refs?.followForm?.clearValidate();
        } catch (error) {
          this.$message.error(error.msg || '提交失败，请重试');
        }
      })
    },
    handleChangeNextTime () {
      // 清除时间则清空跟进时间限制选项
      if (!this.followModel.next_follow_up_time) {
        this.$set(this.followModel, 'next_follow_up_time_type', '');
        this.$set(this.followModel, 'disable_time_type', false);
      } else {
        // 比较下次跟进时间与当前时间差
        const diff = this.followModel.next_follow_up_time - new Date().getTime();
        if (diff < 15 * 60 * 1000) {
          this.diffType = 1;
          this.$set(this.followModel, 'disable_time_type', true);
          this.$set(this.followModel, 'next_follow_up_time_type', '');
        } else {
          if (diff < 60 * 60 * 1000) this.diffType = 2;
          else if (diff < 3 * 60 * 60 * 1000) this.diffType = 3;
          else if (diff < 24 * 60 * 60 * 1000) this.diffType = 4;
          else this.diffType = 5;
          this.$set(this.followModel, 'disable_time_type', false);
          this.$set(this.followModel, 'next_follow_up_time_type', this.diffType - 1);
        }
      }
    }
  },
}
</script>
<style lang="less" scoped>
.next-follow-times{
  font-size: 12px;
  margin-top: 15px;
  padding-bottom: 5px;
  color: #666;
}
</style>
<style lang="less">
.follow-admin-select{
  .el-select__tags>span{
    display: -webkit-box;
    width: 100%;
    overflow: hidden;
  }
  .el-tag.el-tag--info{
    height: 20px;
    line-height: 16px;
    display: block;
    margin-top: 5px;
  }
  .el-select__tags{
    height: 30px;
  }
}
.custome-add-follw-extract{
  display: -webkit-box;
  -webkit-box-align: center;
  margin-top: 10px;
  -webkit-box-pack: justify;
  .extra-label{
    font-size: 12px;
    color: #999;
    margin-right: 10px;
  }
}
.add-follow-style{
  width: 190px;
  .el-input__inner,.el-input__icon{
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
}
.mt15{
  margin-top: 15px !important;
}
</style>